import React, { useEffect} from 'react';
import {multilineText} from 'common/util/common-helpers';
import {updateDocumentTitle} from 'www/util/www-helpers';

const PrivacyPolicy = (props) => {


        useEffect(() => {
            updateDocumentTitle('Privacy Policy');
        }, []);

        const {privacy} = props.settings;
        return (
            <div className="content privacy">
                <header>
                    <h1>Privacy Policy</h1>
                </header>
                <main>{multilineText(privacy)}</main>
            </div>
        );

    }

    export default PrivacyPolicy;
